import { render, staticRenderFns } from "./TalkBubble.vue?vue&type=template&id=7257f168&"
import script from "./TalkBubble.vue?vue&type=script&lang=js&"
export * from "./TalkBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports